import { toast } from "react-toastify";

export default function permissionDeniedToast() {
  toast.info("You are not permitted to perfom this action");
}
